module.exports = __webpack_public_path__ + "static/media/trial2_3.97138a75.png";